var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-is",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M85.4 0h486v486h-486z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 0,
    clipPath: "url(#a)",
    transform: "translate(-90) scale(1.0535)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003897",
    d: "M0 0h675v486H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 189h189V0h108v189h378v108H297v189H189V297H0V189z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d72828",
    d: "M0 216h216V0h54v216h405v54H270v216h-54V270H0v-54z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIs);
export default __webpack_public_path__ + "static/media/is.a511845750f88f10736072b0430d3066.svg";
export { ForwardRef as ReactComponent };